import React from 'react';
import { ProductionTraits } from '../types/instrumentForge.types';
import { TRAIT_DISPLAY_INFO } from '../data/productionTraits';

interface ProductionDNARadarProps {
  traits: ProductionTraits;
}

const ProductionDNARadar: React.FC<ProductionDNARadarProps> = ({ traits }) => {
  const traitKeys = Object.keys(traits) as Array<keyof ProductionTraits>;
  
  return (
    <div className="space-y-3 bg-slate-900/40 p-5 rounded-2xl border-l-4 border-l-accent">
      <h4 className="text-[11px] font-black text-slate-400 uppercase tracking-widest mb-2">Production DNA Architecture</h4>
      {traitKeys.map(key => {
        const value = traits[key];
        const info = TRAIT_DISPLAY_INFO[key];
        return (
          <div key={key} className="space-y-1">
            <div className="flex justify-between items-center text-[11px] font-bold uppercase tracking-tighter">
              <span className="text-slate-400">{info.label}</span>
              <span className="text-accent font-mono">{value.toFixed(1)}</span>
            </div>
            <div className="h-1.5 bg-slate-950 rounded-full overflow-hidden border border-slate-800">
              <div
                className="h-full bg-accent transition-all duration-500 ease-out shadow-[0_0_10px_rgba(192, 93, 62,0.3)]"
                style={{ width: `${value * 10}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductionDNARadar;
